module.exports = __webpack_public_path__ + "1a366a72a98d540653e95080a2d7e2ac.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/pizza-s.png
// module id = 2584
// module chunks = 0